import { createPhaseAction } from 'src/helpers/redux'
import {
  IAssigneNumberParams,
  IAssigneRcNumber,
  IGetAvailableNumbersParams,
  IDeleteAccount,
  IAssignUserToAccountParams,
  IAssignUserToNumberParams,
} from 'src/services/numbers'
import type * as accountsType from 'src/services/accounts'

export const PREFIX = 'numbers'
export const SAGA = `${PREFIX}/saga`

export const actions = {
  getAvailableNumbersTwillio: createPhaseAction<IGetAvailableNumbersParams>(
    `${SAGA}/getAvailableNumbers`
  ),
  getAvailableNumbersRc: createPhaseAction<void>(
    `${SAGA}/getAvailableNumbersRc`
  ),
  assigneTwillioNumber: createPhaseAction<IAssigneNumberParams>(
    `${SAGA}/assigneNumber`
  ),
  assigneRcNumber: createPhaseAction<IAssigneRcNumber>(
    `${SAGA}/assigneRcNumber`
  ),
  getNumbers: createPhaseAction<accountsType.IGetAccounts>(
    `${SAGA}/getNumbers`
  ),

  getAccount: createPhaseAction<accountsType.IGetAccountParams>(
    `${SAGA}/getAccount`
  ),
  postAccountsUpdate: createPhaseAction<accountsType.IPostAccountsUpdateParams>(
    `${SAGA}/postAccountsUpdate`
  ),
  deleteAccounts: createPhaseAction<accountsType.IDeleteAccountParams>(
    `${SAGA}/deleteAccounts`
  ),

  fetchMore: createPhaseAction<accountsType.IGetAccounts>(`${SAGA}/fetchMore`),
  // the settings page: the API decides between the own and the whole workspace list
  getWorkspaceNumbers: createPhaseAction<accountsType.IGetAccounts>(
    `${SAGA}/getWorkspaceNumbers`
  ),
  fetchMoreWorkspaceNumbers: createPhaseAction<accountsType.IGetAccounts>(
    `${SAGA}/fetchMoreWorkspaceNumbers`
  ),
  releaseNumber: createPhaseAction<IDeleteAccount>(`${SAGA}/releaseNumber`),
  assignUserToAccount: createPhaseAction<IAssignUserToAccountParams>(
    `${SAGA}/assignUserToAccount`
  ),
  assignUserToNumber: createPhaseAction<IAssignUserToNumberParams>(
    `${SAGA}/assignUserToNumber`
  ),
}
export type Actions = typeof actions
